import React from 'react';
import styled from 'styled-components';
import { Box } from '~common/components/box.component';

interface Props {
  title: string;
  subtitle: string;
}

export const ErrorPage: React.FunctionComponent<Props> = ({ title, subtitle, ...rest }) => (
  <Wrapper {...rest}>
    <Title>{title}</Title>
    <Subtitle>{subtitle}</Subtitle>
  </Wrapper>
);

const Title = styled.h1`
  display: inline-block;
  border-right: 1px solid ${(props): string => props.theme.colors.white};
  margin: 0 20px 0 0;
  padding: 10px 23px 10px 0;
  font-size: 24px;
  font-weight: 500;
  vertical-align: top;
  color: ${(props): string => props.theme.colors.white};
`;

const Subtitle = styled(Box)`
  align-items: center;

  font-size: 14px;
  font-weight: normal;
  line-height: inherit;
  margin: 0;
  padding: 0;
  color: ${(props): string => props.theme.colors.white};
`;

const Wrapper = styled(Box)`
  width: 100vw;
  height: 100%;
  justify-content: center;
  align-items: center;
  padding: 24px;
`;



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/common/src/components/core/error-page.component.tsx